import { animateCampaign } from "../Campaign/campaign-animation";

const campaignLinkBlocks = document.querySelectorAll<HTMLElement>(
  "[id^='data-campaign-link']"
);

animateCampaign(campaignLinkBlocks);
